import { isLinkTo } from 'ember-route-state/utils/link-to.js';
import { isRouteInfo } from 'ember-route-state/utils/route-info.js';

export function routeName(route) {
  return !route || typeof route === 'string' ? route
    : isLinkTo(route) ? route.route
    : isRouteInfo(route) ? route.name
    : Array.isArray(route) ? Array.isArray(route[0]) ? route[0][0] : route[0]
    : undefined;
}
